import { getCountryNameByCode } from '@dealstack/shared/lib/countries/countriesData.ts';
import { InvestmentDetailsBankInformation } from '@dealstack/shared/lib/generated';

export interface BankInformationRow {
	label: string;
	value: string;
}

// Resolved by the caller so this stays free of the i18n hook.
export interface BankInformationLabels {
	accountHolder: string;
	bankName: string;
	accountNumber: string;
	swiftCode: string;
	iban: string;
	country: string;
	currency: string;
}

/**
 * Only the fields the account actually carries. Every classic field is optional under the
 * identifier model — a GB sort-code account has no IBAN, a PIX account no account number —
 * so listing them unconditionally rendered rows holding nothing but a dash.
 */
export const getBankInformationRows = (
	bankInformation: InvestmentDetailsBankInformation,
	labels: BankInformationLabels
): BankInformationRow[] =>
	[
		{ label: labels.accountHolder, value: bankInformation.accountHolder },
		{ label: labels.bankName, value: bankInformation.bankName },
		{ label: labels.accountNumber, value: bankInformation.accountNumber },
		{ label: labels.swiftCode, value: bankInformation.swiftCode },
		{ label: labels.iban, value: bankInformation.iban },
		...bankInformation.identifiers,
		// Named rather than coded: the card is read, not parsed. An unmappable legacy
		// country resolves to null and drops out with everything else empty.
		{ label: labels.country, value: getCountryNameByCode(bankInformation.countryCode) },
		{ label: labels.currency, value: bankInformation.currency },
	].filter((row): row is BankInformationRow => !!row.value?.trim());
